export default __webpack_public_path__ + "static/fall23-498051dd3809bd02b1c196ece18777a4.webp";